import { inject, Injectable } from '@angular/core';
import { DialogService, ShoppingcartService, SigninComponent } from '@prekog/common-ui';
import { Material } from './material.model';

@Injectable({
    providedIn: 'root'
})
export class PublicationService {

    private _dialogService = inject(DialogService);

    constructor(
        private _shoppingcartService: ShoppingcartService,
    ) { }

    addToCart(material: Material) {
        this._shoppingcartService.addToCart(material);
    }

    openLogin() {
        this._dialogService.openDialog(SigninComponent);
    }
}
